import { render, staticRenderFns } from "./RecurrentPricesModal.vue?vue&type=template&id=b7c55658&scoped=true"
import script from "./RecurrentPricesModal.vue?vue&type=script&lang=js"
export * from "./RecurrentPricesModal.vue?vue&type=script&lang=js"
import style0 from "./RecurrentPricesModal.vue?vue&type=style&index=0&id=b7c55658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c55658",
  null
  
)

export default component.exports